import React, { useState } from 'react';
import { showError } from '../../utils';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as IconPriority } from '../../assets/icons/star.svg';
import { ReactComponent as IconPriorityN } from '../../assets/icons/star-n.svg';
import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';


const PriorityButton = ({ contattoId, initial, contatto_title, numero }) => {
    const navigate = useNavigate();
    
    if (initial === null) initial = 'no';

    const PRIORITY_MAP = {
        'no': { class: 'no', Icon: IconPriority },
        'no-with-note': { class: 'no-with-note', Icon: IconPriorityN },
        'yes': { class: 'yes', Icon: IconPriority },
        'yes-with-note': { class: 'yes-with-note', Icon: IconPriorityN }
    }

    const [priority, setPriorityState] = useState(initial);
    const [loadingPriority, setLoadingPriority] = useState(false);

    const { class: priorityClass, Icon } = PRIORITY_MAP[priority] || PRIORITY_MAP['no'];
    return (
        <button className={`priority-btn ${priorityClass}`} disabled={loadingPriority}  onClick={() => navigate('/contattopriorita', { state: { id: contattoId, contatto_title, numero } })} >
            
            {loadingPriority ? <IconLoading className="icon icon-loading"/> : <Icon className="icon" />}
        </button>
    );
}
export default PriorityButton;